import { CSSObject } from '@emotion/core';

import { colors, scale, typography } from '@scripts/gds';

export const tableHeadStyles: CSSObject = {
    th: {
        backgroundColor: colors.backgroundMain,
        ...typography('bodySmRegular'),
        color: colors.textSecondGrey,
        height: scale(6),
        verticalAlign: 'middle',
        border: 'none',
        padding: `${scale(1)}px ${scale(2)}px`,
    },
};

export const tableHeadStylesAdditional: CSSObject = {
    th: {
        lineHeight: '1.6',
    },
};

export const tableStyles: CSSObject = {
    overflow: 'inherit',
    td: {
        verticalAlign: 'middle',
        backgroundColor: '#fff',
        borderBottom: `1px solid ${colors.backgroundMain}`,
        color: colors.textSecondGrey,
        padding: `${scale(1)}px ${scale(2)}px`,
        marginBottom: scale(4),
    },
    tr: {
        position: 'relative',
    },
    'tbody tr:hover': {
        boxShadow: '0px 4px 16px rgba(61, 123, 160, 0.25)',
        zIndex: 3,
    },
    width: '100%',
    tableLayout: 'fixed',
    'tr td:nth-of-type(1)': {
        width: '32%',
    },
    'tr td:nth-of-type(2)': {
        width: '10%',
        maxWidth: scale(13),
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    'tr td:nth-of-type(3)': {
        width: '12%',
    },
    'tr td:nth-of-type(4)': {
        width: '14%',
    },
    'tr td:nth-of-type(5)': {
        width: '5%',
    },
};

export const tableStylesAdditional: CSSObject = {
    td: {
        borderBottom: `1px solid ${colors.borderMain}`,
    },
    tr: {
        lineHeight: 1.6,
    },
    'tr td:nth-of-type(1)': {
        width: '19%',
        color: colors.textMainBlack,
    },
    'tr td:nth-of-type(2)': {
        width: '19%',
        color: colors.textMainBlack,
    },
    'tr td:nth-of-type(3)': {
        width: '25%',
        whiteSpace: 'normal',
        color: colors.textMainBlack,
    },
    'tr td:nth-of-type(4)': {
        width: '14%',
    },
    'tr td:nth-of-type(5)': {
        width: '23%',
    },
};
